import React from "react";

function PatientAppSection() {
  return (
    <section id="patient-app" className="section section--alt patient-app">
      <div className="patient-app__grid">
        <div className="patient-app__copy">
          <p className="eyebrow">Powered by XsBenefits</p>
          <h2>Their health, in their hands.</h2>
          <p>
            Every Byondcare plan includes the XsBenefits patient health app.
            Consultation history, lab results, appointment reminders, and direct
            clinic messaging, all from their phone.
          </p>
          <div className="patient-app__chips">
            <span>Included with every plan</span>
            <span>iOS & Android</span>
            <span>WhatsApp reminders</span>
            <span>Health records</span>
            <span>Lab results</span>
          </div>
          <ul className="patient-app__benefits">
            <li>Reduce no-shows with automated appointment reminders.</li>
            <li>Reduce front desk calls as patients access records directly.</li>
            <li>Build loyalty through continuous care between visits.</li>
          </ul>
        </div>
        <div className="patient-app__cta">
          <p>Get XsBenefits app</p>
          <a
            href="https://apps.apple.com/my/app/xsbenefits/id1660439949"
            target="_blank"
            rel="noreferrer"
            className="patient-app__store-btn"
            aria-label="Download on the App Store"
          >
            <img src="/images/appstore.svg" alt="Download on the App Store" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.lll.xsbenefits.prod"
            target="_blank"
            rel="noreferrer"
            className="patient-app__store-btn"
            aria-label="Get it on Google Play"
          >
            <img src="/images/googleplay.png" alt="Get it on Google Play" />
          </a>
        </div>
      </div>
    </section>
  );
}

export default PatientAppSection;
